import React from "react";
// Adjust the import path to where you saved the FormattedText component
import FormattedText from "../../Utility/FormattedText"; 

const ExplanationCard = ({ correctAnswer, comments }) => {
  // Guard clause: If there's no data, don't render an empty card
  if (!correctAnswer && (!comments || comments.length === 0)) {
    return null;
  }

  return (
    <div className="w-full max-w-4xl mx-auto mt-6">
      <div className="border border-gray-300 p-6 rounded-lg bg-white shadow-sm">
        
        {/* --- MAIN HEADLINE --- */}
        <h2 className="text-xl font-bold text-gray-900 mb-6 border-b border-gray-100 pb-2">
          Solution & Analysis
        </h2>

        {/* --- CORRECT ANSWER SECTION --- */}
        {correctAnswer && (
          <div className="mb-8">
            <h3 className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-2">
              Correct Answer
            </h3>
            {/* Using Green background to highlight the correct answer */}
            <div className="bg-green-50 border border-green-100 rounded-md p-4 text-gray-800">
              <FormattedText text={correctAnswer} />
            </div>
          </div>
        )}

        {/* --- COMMENTS / EXPLANATION SECTION --- */}
        {comments && comments.length > 0 && (
          <div className="space-y-6">
            {comments.map((comment, index) => (
              <div key={index} className="flex flex-col">
                {/* Comment Headline (e.g., "POINT 1") */}
                <h3 className="text-xs font-bold text-gray-400 uppercase tracking-wide mb-1">
                  Comment {index + 1}
                </h3>
                
                {/* Comment Content */}
                <div className="text-gray-800 pl-1 border-l-2 border-gray-200 ml-1">
                   <div className="pl-3">
                      <FormattedText text={comment} />
                   </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ExplanationCard;